// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__FAFx8","header":"MessagesList_header__1hqbI","chat":"MessagesList_chat__3fcXr"};